import React from "react";
import axios from "axios";
import { Navigate } from 'react-router-dom';
import Layout from "./Components/Layout";
import PhoneNumberInput from "./Components/PhoneNumberInput";
import { useParams } from 'react-router-dom';
import { useState } from 'react';
import {toast, ToastContainer} from "react-toastify";

function AddSupplier() {

    const [state, setState] = useState({
        username: '',
        password: '',
        firstname: '',
        lastname: '',
        phone: '',
        company: '',
        paymentTerms: '',
        creditLine: '',
        fobOrigin: '',
        fobDest: '',
        shippingAddress: '',
        formError: false,
        redirect: false,
        userId: 0,
        submitBtnTxt:'Create'
    });

    const handleUsernameInput = (event) => {
        console.log(event.target.value);
        setState(prevState => ({
            ...prevState,
            username: event.target.value
        }));
    };

    const handlePasswordInput = (event) => {
        console.log(event.target.value);
        setState(prevState => ({
            ...prevState,
            password: event.target.value
        }));
    };

    const handleFirstnameInput = (event) => {
        console.log(event.target.value);
        setState(prevState => ({
            ...prevState,
            firstname: event.target.value
        }));
    };

    const handleLastnameInput = (event) => {
        console.log(event.target.value);
        setState(prevState => ({
            ...prevState,
            lastname: event.target.value
        }));
    };

    const handleCompanyInput = (event) => {
        console.log(event.target.value);
        setState(prevState => ({
            ...prevState,
            company: event.target.value
        }));
    };

    const handlePaymentTermsInput = (event) => {
        console.log(event.target.value);
        setState(prevState => ({
            ...prevState,
            paymentTerms: event.target.value
        }));
    };

    const handleCreditLineInput = (event) => {
        console.log(event.target.value);
        setState(prevState => ({
            ...prevState,
            creditLine: event.target.value
        }));
    };

    const handleFobOriginInput = (event) => {
        console.log(event.target.value);
        setState(prevState => ({
            ...prevState,
            fobOrigin: event.target.value
        }));
    };

    const handleFobDestInput = (event) => {
        console.log(event.target.value);
        setState(prevState => ({
            ...prevState,
            fobDest: event.target.value
        }));
    };

    const handleShippingAddressInput = (event) => {
        console.log(event.target.value);
        setState(prevState => ({
            ...prevState,
            shippingAddress: event.target.value
        }));
    };

    const handlePhoneInput = (event) => {
        console.log(event);
        const phone = event;
        setState(prevState => ({
            ...prevState,
            phone: phone
        }));
    };

    const onKeyUp = (event) => {
        if (event.charCode === 13) {
            authenticate(event);
        }
    };

    const authenticate = (event) => {
        let userObj = {
            username: state.username,
            password: state.password,
            firstname: state.firstname,
            lastname: state.lastname,
            phone: state.phone,
            company: state.company,
            paymentTerms: state.paymentTerms,
            creditLine: state.creditLine,
            fobOrigin: state.fobOrigin,
            fobDest: state.fobDest,
            shippingAddress: state.shippingAddress
        }

        if (state.username !== "" &&
            state.password !== "" &&
            state.firstname !== "" &&
            state.lastname !== "" &&
            state.phone !== "" &&
            state.company !== "" &&
            state.paymentTerms !== "") {

            setState(prevState => ({
                ...prevState,
                formError: false,
                submitBtnTxt: 'Creating'
            }));

            axios.post(`supauth/`, userObj)
                .then(response => {
                    if (response.data.userCreated === 200) {
                        toast.success('Account Created Successfully!');
                        setTimeout(() => {
                            setState(prevState => ({
                                ...prevState,
                                redirect: true,
                                userId: response.data.user_id,
                                submitBtnTxt: 'Created'
                            }));
                        }, 2000);
                    } else if (response.data.userCreated === 409) {
                        toast.success('User/Account Already Exists!');
                    } else {
                        toast.error('Something went wrong, try again later');
                    }
                }).catch(error => {
                toast.error('There was an error!', error);
            });
        } else {
            setState(prevState => ({
                ...prevState,
                formError: true
            }));
        }
    };

    if (state.redirect) {
        return (<Navigate to={`/add-supplier-record/${state.userId}`} />);
    } else {
        return (
            <Layout>
                <div style={{ height: 'calc(100vh - 70px)', overflow: 'auto', padding: '20px 0px' }}>
                    <div className="container-fluid">
                        <div className="row">
                            
                            <div className="col-lg-8">
                                <div className="card" style={{ border: '1px solid #e5e7eb' }}>
                                    <div className="card-header">
                                        <h5 className="mb-0">Supplier Information</h5>
                                    </div>
                                    <div className="card-body">
                                        <form>
                                            <div className="row">
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label">First Name <span className="text-danger">*</span></label>
                                                    <input 
                                                        type="text" 
                                                        name="firstname" 
                                                        onKeyPress={onKeyUp}
                                                        onChange={handleFirstnameInput} 
                                                        id="firstname"
                                                        className="form-control"
                                                        style={{ height: '45px' }}
                                                        placeholder="Enter first name"
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label">Last Name <span className="text-danger">*</span></label>
                                                    <input 
                                                        type="text" 
                                                        name="lastname" 
                                                        onKeyPress={onKeyUp}
                                                        onChange={handleLastnameInput} 
                                                        id="lastname"
                                                        className="form-control"
                                                        style={{ height: '45px' }}
                                                        placeholder="Enter last name"
                                                    />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label">Company <span className="text-danger">*</span></label>
                                                    <input 
                                                        type="text" 
                                                        name="company" 
                                                        onKeyPress={onKeyUp}
                                                        onChange={handleCompanyInput} 
                                                        id="company"
                                                        className="form-control"
                                                        style={{ height: '45px' }}
                                                        placeholder="Enter company name"
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label">Cell Phone <span className="text-danger">*</span></label>
                                                    <PhoneNumberInput onPhoneNumberChange={handlePhoneInput} />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label">Email <span className="text-danger">*</span></label>
                                                    <input 
                                                        type="email" 
                                                        name="email" 
                                                        onKeyPress={onKeyUp}
                                                        onChange={handleUsernameInput} 
                                                        id="email" 
                                                        className="form-control"
                                                        style={{ height: '45px' }}
                                                        placeholder="Enter email address"
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label">Password <span className="text-danger">*</span></label>
                                                    <input 
                                                        type="password" 
                                                        onKeyPress={onKeyUp}
                                                        onChange={handlePasswordInput} 
                                                        name="password" 
                                                        id="password"
                                                        className="form-control"
                                                        style={{ height: '45px' }}
                                                        placeholder="Enter password"
                                                    />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label">Payment Terms <span className="text-danger">*</span></label>
                                                    <input 
                                                        type="text" 
                                                        name="payment-terms" 
                                                        onKeyPress={onKeyUp}
                                                        onChange={handlePaymentTermsInput} 
                                                        id="payment-terms"
                                                        className="form-control"
                                                        style={{ height: '45px' }}
                                                        placeholder="e.g., NET 30"
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label">Credit Line</label>
                                                    <input 
                                                        type="text" 
                                                        name="credit-line" 
                                                        onKeyPress={onKeyUp}
                                                        onChange={handleCreditLineInput} 
                                                        id="credit-line"
                                                        className="form-control"
                                                        style={{ height: '45px' }}
                                                        placeholder="Enter credit limit"
                                                    />
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label">FOB Origin</label>
                                                    <input 
                                                        type="text" 
                                                        name="fob-origin" 
                                                        onKeyPress={onKeyUp}
                                                        onChange={handleFobOriginInput} 
                                                        id="fob-origin"
                                                        className="form-control"
                                                        style={{ height: '45px' }}
                                                        placeholder="Enter FOB origin"
                                                    />
                                                </div>
                                                <div className="col-md-6 mb-3">
                                                    <label className="form-label">FOB Destination</label>
                                                    <input 
                                                        type="text" 
                                                        name="fob-destination" 
                                                        onKeyPress={onKeyUp}
                                                        onChange={handleFobDestInput} 
                                                        id="fob-destination"
                                                        className="form-control"
                                                        style={{ height: '45px' }}
                                                        placeholder="Enter FOB destination"
                                                    />
                                                </div>
                                            </div>

                                            <div className="mb-3">
                                                <label className="form-label">Shipping Address</label>
                                                <input 
                                                    type="text" 
                                                    name="shipping-address" 
                                                    onKeyPress={onKeyUp}
                                                    onChange={handleShippingAddressInput} 
                                                    id="shipping-address"
                                                    className="form-control"
                                                    style={{ height: '45px' }}
                                                    placeholder="Enter shipping address"
                                                />
                                            </div>

                                            {state.formError && (
                                                <div className="alert alert-danger" role="alert">
                                                    <i className="ti-alert-circle me-2"></i>
                                                    All required fields must be filled out.
                                                </div>
                                            )}

                                            <div className="d-flex gap-2 mt-4">
                                                <button 
                                                    type="button" 
                                                    onClick={authenticate} 
                                                    className="btn btn-primary"
                                                    style={{ height: '45px', padding: '0 24px' }}
                                                    disabled={state.submitBtnTxt === 'Creating'}
                                                >
                                                    <i className="ti-check me-2"></i>
                                                    {state.submitBtnTxt}
                                                </button>
                                                <button 
                                                    type="button" 
                                                    className="btn btn-secondary"
                                                    style={{ height: '45px', padding: '0 24px' }}
                                                    onClick={() => window.history.back()}
                                                >
                                                    <i className="ti-arrow-left me-2"></i>
                                                    Cancel
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </Layout>
        );
    }
}

export default AddSupplier;